/* eslint-disable eqeqeq */
import React, { useState } from 'react';
import Container, { ContainerPadding } from '../Container';

const Header = () => {
  const [dropdownState, setDropdownState] = useState(false);
  const [dropdownValue, setDropdownValue] = useState('العربية');

  const handleDropdownClick = () => {
    setDropdownState(!dropdownState);
  };
  const handleSetDropdownValue = (value) => {
    setDropdownValue(value);
    setDropdownState(!dropdownState);
  };

  return (
    <header id='header'>
      <div id='header-bar-1' className='header-bar'>
        <div className='header-bar-wrap'>
          <Container>
            <ContainerPadding width='98%'>
              <div className='row'>
                <div className='col-md-12 space_between'>
                  <div className='links'>
                    <a href='#about'>من نحن</a>
                    <a href='#why'>لماذا لمعة الإبداع </a>
                    <a href='#message'>الرسالة والرؤية </a>
                    <a href='#services'>خدماتنا </a>
                    <a href='#contact_us'> تواصل معنا</a>
                    <div className={'custom_dropdown'}>
                      <button
                        onClick={handleDropdownClick}
                        className='dropdown-btn'>
                        <span>{dropdownValue}</span>
                        {dropdownValue == 'العربية' ? (
                          <svg
                            height='200px'
                            width='200px'
                            id='Layer_1'
                            xmlns='http://www.w3.org/2000/svg'
                            xmlnsXlink='http://www.w3.org/1999/xlink'
                            viewBox='0 0 496 496'
                            xmlSpace='preserve'
                            fill='#000000'>
                            <g id='SVGRepo_bgCarrier' strokeWidth={0} />
                            <g
                              id='SVGRepo_tracerCarrier'
                              strokeLinecap='round'
                              strokeLinejoin='round'
                            />
                            <g id='SVGRepo_iconCarrier'>
                              <path
                                style={{
                                  fill: '#009966',
                                }}
                                d='M496,369.6c0,27.2-21.6,48.8-48,48.8H48c-26.4,0-48-21.6-48-48.8V126.4c0-27.2,21.6-48.8,48-48.8h400 c26.4,0,48,21.6,48,48.8V369.6z'
                              />
                              <path
                                style={{
                                  fill: '#038E5C',
                                }}
                                d='M48,77.6h400c26.4,0,48,21.6,48,48.8v243.2c0,27.2-21.6,48.8-48,48.8'
                              />
                              <g>
                                <path
                                  style={{
                                    fill: '#007A54',
                                  }}
                                  d='M496,369.6c0,27.2-21.6,48.8-48,48.8H48c-26.4,0-48-21.6-48-48.8'
                                />
                                <path
                                  style={{
                                    fill: '#007A54',
                                  }}
                                  d='M48,77.6h400c26.4,0,48,21.6,48,48.8v88.8'
                                />
                              </g>
                              <g>
                                <path
                                  style={{
                                    fill: '#FFFFFF',
                                  }}
                                  d='M60.8,155.2c3.2-2.4,3.2,4,0,11.2c1.6-2.4,4.8-8,4-12c-0.8-5.6-4-4.8-6.4-1.6 C56.8,155.2,57.6,156.8,60.8,155.2z'
                                />
                                <path
                                  style={{
                                    fill: '#FFFFFF',
                                  }}
                                  d='M61.6,200.8c4-7.2,2.4-12.8,5.6-23.2c2.4-6.4,2.4-1.6,2.4,2.4c-1.6,10.4-0.8,27.2,13.6,26.4 c0.8,9.6,3.2,26.4,3.2,32.8c0,5.6,0.8,4,2.4,0.8c1.6-3.2,0.8-7.2,0.8-12c0-4.8-0.8-13.6-1.6-25.6c1.6-1.6,4-4,4.8-5.6 c1.6-4,2.4-3.2,3.2,0c1.6,6.4,8,10.4,16,4c8-5.6,4.8-16.8,0.8-28.8c3.2,0.8,4-1.6,2.4-4.8c-0.8-1.6-2.4-3.2-3.2-4.8 c-1.6-1.6-2.4-3.2-4-1.6s-2.4,3.2-3.2,4c-0.8,0.8-0.8,2.4,0,4.8c3.2,7.2,4.8,15.2,5.6,19.2c0.8,4-0.8,4.8-4,4.8 c-2.4,0-6.4-0.8-8-7.2s-2.4-8.8-1.6-13.6c0-4,0.8-7.2-2.4-11.2c-3.2-4-3.2-3.2-4-1.6c-0.8,2.4-1.6,5.6-0.8,9.6 c1.6,5.6,2.4,10.4,3.2,13.6c0.8,2.4-1.6,7.2-5.6,9.6c-0.8-8-1.6-17.6-2.4-26.4c4.8-1.6,2.4-7.2-1.6-13.6c-2.4-4.8-4-3.2-5.6,0 c-1.6,3.2-0.8,4.8,0.8,7.2c-0.8,2.4,0.8,5.6,1.6,11.2c0.8,4,1.6,14.4,1.6,23.2c-3.2,0-5.6-2.4-7.2-5.6c-2.4-6.4-2.4-12.8-0.8-16 c1.6-4,2.4-9.6,0-11.2s-4.8,0-6.4,3.2c-3.2,4.8-6.4,11.2-6.4,18.4c0,2.4-0.8,8-2.4,10.4c-0.8,2.4-3.2,2.4-4.8-0.8 c-3.2-4.8-4-17.6-4-24c0-3.2-0.8-4-1.6,0c-3.2,12.8,0.8,25.6,3.2,31.2C55.2,207.2,59.2,205.6,61.6,200.8z'
                                />
                                <path
                                  style={{
                                    fill: '#FFFFFF',
                                  }}
                                  d='M100,159.2c1.6-1.6,1.6-1.6,2.4,0s3.2,1.6,4,0s1.6-2.4,0.8-4.8c-0.8-1.6-0.8-0.8-1.6,0.8 c-0.8,3.2-4,2.4-4-1.6s-0.8-1.6-2.4,0.8c-1.6,4-4,3.2-4-0.8c0-2.4-0.8-4.8-2.4-1.6c-0.8,2.4,0,4.8,0.8,6.4 C96,160.8,98.4,160.8,100,159.2z'
                                />
                                <path
                                  style={{
                                    fill: '#FFFFFF',
                                  }}
                                  d='M76,219.2c2.4-0.8,2.4-0.8,2.4-4c0-3.2-1.6-1.6-4.8-0.8c-4.8,1.6-14.4,6.4-21.6,15.2 c-3.2,4-0.8,2.4,1.6,0.8C57.6,227.2,69.6,220.8,76,219.2z'
                                />
                                <path
                                  style={{
                                    fill: '#FFFFFF',
                                  }}
                                  d='M60,270.4c-2.4,4-7.2-1.6-4-12c0.8-2.4,1.6-4,1.6-5.6s0-3.2,0-5.6c0-1.6-1.6,0.8-2.4,4 c-0.8,4.8-4,7.2-3.2,22.4c0.8,8.8,11.2,8.8,12-2.4C64,266.4,62.4,266.4,60,270.4z'
                                />
                                <path
                                  style={{
                                    fill: '#FFFFFF',
                                  }}
                                  d='M131.2,236.8c0-4-0.8-8-0.8-12c0.8,0,0.8-0.8,1.6-0.8c2.4,7.2,12.8,5.6,16,0.8 c1.6-2.4,1.6-2.4,3.2,0c2.4,3.2,10.4,4.8,12,0c1.6-4.8,1.6-9.6,0.8-12.8c-0.8-4-1.6-3.2-4-1.6c-2.4,1.6-0.8,2.4,0,4.8 c0.8,9.6-7.2,8.8-8-0.8c-0.8-6.4-1.6-4-2.4-0.8c-4,12-14.4,14.4-12.8,0c0-4-2.4-2.4-4-0.8c-0.8,0.8-2.4,2.4-3.2,3.2 c-0.8-11.2-1.6-24-3.2-40c3.2,4,6.4-0.8,4-4.8c-1.6-3.2-4-11.2-5.6-15.2s-2.4-3.2-5.6,0.8c-3.2,3.2-2.4,4-1.6,8 c0,4.8,0,8.8,1.6,17.6c0.8,6.4,2.4,20,4,36.8c-1.6,0.8-4,2.4-5.6,3.2c-0.8-3.2-3.2-4.8-6.4-8c-4.8-4.8-8-4.8-12,0.8 s-3.2,6.4-3.2,12c0,4.8-0.8,6.4,3.2,8s5.6,0.8,8,0c1.6-0.8,4-1.6,7.2-2.4c0.8,2.4,0,5.6-1.6,7.2c-9.6,11.2-24,20-30.4,12 c-3.2-4-4.8-10.4-4-18.4c0.8-6.4-0.8-3.2-1.6-1.6c-2.4,7.2-3.2,18.4,0,24c4,8,11.2,11.2,22.4,5.6c11.2-4.8,21.6-13.6,21.6-25.6 c0-2.4,0-4,0-5.6c1.6-0.8,3.2-1.6,4-2.4c0,4,0,9.6,0,13.6c0.8,12.8-4.8,16.8-9.6,20.8c-6.4,4.8-15.2,8.8-23.2,9.6 c-17.6,2.4-21.6-8.8-21.6-24c0-2.4,0.8-4,0.8-7.2c0-6.4-0.8-5.6-3.2,0.8c-1.6,6.4-4,20.8,1.6,32.8c6.4,12,27.2,8.8,43.2,0.8 C130.4,266.4,132,252,131.2,236.8z M108.8,224.8c-4,1.6-5.6-0.8-4.8-3.2c0-2.4,0.8-4,4-2.4c1.6,0.8,3.2,2.4,4.8,4.8 C110.4,224.8,109.6,224.8,108.8,224.8z'
                                />
                                <path
                                  style={{
                                    fill: '#FFFFFF',
                                  }}
                                  d='M149.6,250.4c1.6-3.2,2.4-6.4,1.6-10.4c-0.8-2.4,0-3.2-2.4-4.8c-2.4-0.8-3.2,0.8-4,2.4 c-0.8,2.4,0.8,5.6,4,4c0.8,1.6,0,5.6-0.8,8C147.2,252.8,148,253.6,149.6,250.4z'
                                />
                                <path
                                  style={{
                                    fill: '#FFFFFF',
                                  }}
                                  d='M156,185.6c-3.2,4-5.6,9.6-0.8,12.8c2.4,1.6,7.2-0.8,8.8-4c1.6-4,0.8-4.8-2.4-0.8 c-4,4.8-8.8,0.8-4-6.4C160.8,182.4,158.4,181.6,156,185.6z'
                                />
                                <path
                                  style={{
                                    fill: '#FFFFFF',
                                  }}
                                  d='M142.4,186.4c11.2-4.8,17.6-11.2,20.8-16.8c3.2,0.8,4-1.6,2.4-4c0.8-2.4,1.6-4,2.4-5.6 c2.4-10.4-8-11.2-10.4-3.2c-1.6,4-1.6,8,1.6,10.4c-4.8,6.4-11.2,12-19.2,16.8C136.8,187.2,137.6,188.8,142.4,186.4z M161.6,158.4 c0.8-2.4,2.4-0.8,2.4,0.8c0,0.8-0.8,2.4-1.6,3.2C160.8,161.6,160.8,160,161.6,158.4z'
                                />
                              </g>
                              <path
                                style={{
                                  fill: '#CFE7E8',
                                }}
                                d='M157.6,156.8c-1.6,4-1.6,8,1.6,10.4c-0.8,0.8-1.6,2.4-2.4,3.2l4,3.2c0.8-1.6,2.4-2.4,3.2-4 c3.2,0.8,4-1.6,2.4-4c0.8-2.4,1.6-4,2.4-5.6C170.4,149.6,160.8,148.8,157.6,156.8z M164,159.2c0,0.8-0.8,2.4-1.6,3.2 c-1.6-0.8-1.6-2.4-0.8-4C162.4,156,164,157.6,164,159.2z'
                              />
                              <path
                                style={{
                                  fill: '#FFFFFF',
                                }}
                                d='M169.6,250.4c-1.6,0.8-4,3.2-5.6,4.8c0-3.2,0.8-8,0.8-9.6c0-2.4-0.8-3.2-2.4-0.8 c-2.4,4.8-4.8,11.2-5.6,16c-10.4,7.2-23.2,14.4-32,18.4c-4,1.6-1.6,3.2,1.6,2.4c12-4,21.6-7.2,30.4-11.2c0.8,7.2,3.2,12,9.6,13.6 c12,3.2,24-7.2,37.6-25.6c3.2,8.8,11.2,20.8,32,24c8.8,1.6,8,0.8,9.6-4c0.8-4,2.4-4.8-4.8-6.4c-8.8-3.2-12-9.6-3.2-13.6 s20.8-7.2,28.8-8.8c5.6-0.8,7.2-0.8,8.8-5.6c1.6-5.6,2.4-6.4-3.2-5.6c-6.4,0.8-36.8,1.6-44.8,0.8c6.4-3.2,15.2-6.4,21.6-8.8 c2.4,1.6,3.2,0.8,2.4-0.8c2.4-0.8,4.8-1.6,7.2-3.2c7.2-4,10.4-12.8,2.4-18.4s-14.4-7.2-18.4-1.6c-3.2,4.8-6.4,9.6-1.6,16 c-7.2,2.4-13.6,4.8-20,7.2c-4.8,1.6-7.2,2.4-8.8,8.8s-2.4,6.4,4,7.2c8.8,0,16.8,0,22.4,4.8c-8.8,3.2-15.2,9.6-12,18.4 c-4-0.8-8-2.4-11.2-5.6c-6.4-6.4-6.4-17.6-8.8-30.4c-2.4-12.8-8-24-10.4-28.8c-1.6-4.8-2.4-2.4-4,0.8c-1.6,3.2-3.2,4.8-1.6,9.6 c3.2,8,8,24,10.4,33.6c-4.8,11.2-17.6,24.8-28,26.4c-8,1.6-10.4-3.2-9.6-7.2c5.6-3.2,10.4-7.2,15.2-12c9.6-10.4,11.2-18.4,4.8-35.2 c4,0.8,3.2-2.4-2.4-9.6c-4-4.8-4.8-4-7.2,0.8c-1.6,4-3.2,7.2,1.6,8.8c0.8,2.4,2.4,5.6,4.8,9.6C184.8,240,176.8,244,169.6,250.4z M245.6,215.2c0-2.4,0.8-2.4,4.8,0c4,2.4,7.2,3.2,1.6,4c-1.6,0.8-4,0.8-5.6,1.6C246.4,218.4,246.4,216.8,245.6,215.2z'
                              />
                              <g>
                                <path
                                  style={{
                                    fill: '#CFE7E8',
                                  }}
                                  d='M271.2,238.4c-4,0-21.6,0.8-33.6,0.8l16,13.6c4-1.6,8.8-2.4,12-3.2c5.6-0.8,7.2-0.8,8.8-5.6 C276,238.4,276.8,237.6,271.2,238.4z'
                                />
                                <path
                                  style={{
                                    fill: '#CFE7E8',
                                  }}
                                  d='M192.8,200.8l1.6,1.6C194.4,200.8,193.6,200.8,192.8,200.8z'
                                />
                                <path
                                  style={{
                                    fill: '#CFE7E8',
                                  }}
                                  d='M233.6,235.2c4.8-2.4,10.4-4,14.4-5.6c2.4,1.6,3.2,0.8,2.4-0.8c2.4-0.8,4.8-1.6,7.2-3.2 c7.2-4,10.4-12.8,2.4-18.4c-8-5.6-14.4-7.2-18.4-1.6c-3.2,4.8-6.4,9.6-1.6,16c-5.6,1.6-10.4,3.2-15.2,5.6L233.6,235.2z M251.2,215.2c4,2.4,7.2,3.2,1.6,4c-1.6,0.8-4,0.8-5.6,1.6c-0.8-2.4-0.8-4-0.8-4.8C245.6,212.8,247.2,212.8,251.2,215.2z'
                                />
                              </g>
                              <path
                                style={{
                                  fill: '#FFFFFF',
                                }}
                                d='M264,280c2.4-0.8,6.4-3.2,9.6-5.6c3.2-3.2,0.8-2.4-1.6-1.6s-4.8,2.4-8,3.2c-3.2,1.6-4,0-2.4-5.6 c1.6-4.8,0-4.8-2.4-4s-3.2,2.4-5.6,4c-1.6,0.8-1.6,2.4,2.4,0.8c3.2-1.6,2.4,0,1.6,4C256,279.2,258.4,281.6,264,280z'
                              />
                              <g>
                                <path
                                  style={{
                                    fill: '#CFE7E8',
                                  }}
                                  d='M189.6,192.8c2.4-5.6,4-11.2,5.6-15.2s3.2-3.2,2.4,0.8c-0.8,7.2-0.8,18.4,6.4,23.2 c7.2,4,18.4-3.2,22.4-11.2c12,15.2,22.4,8,23.2-6.4c0-4.8-1.6-14.4-3.2-17.6c-1.6-3.2,0-3.2,1.6-1.6c1.6,1.6,4.8,3.2,3.2-2.4 c-1.6-4.8-4-8-6.4-10.4s-3.2-0.8-4,0.8s-0.8,2.4-2.4,4s-0.8,2.4,0,4.8c4.8,11.2,8.8,28,1.6,29.6c-6.4,1.6-10.4-12.8-10.4-19.2 c0-8-1.6-15.2-3.2-20c-1.6-4.8-2.4-4.8-4-2.4c-0.8,1.6-0.8,3.2-2.4,4.8c-0.8,1.6,0,2.4,0.8,5.6c4,18.4,3.2,26.4-4.8,31.2 c-8,4.8-12.8,0-12.8-5.6s0-12.8,0.8-17.6c0.8-4.8,1.6-6.4,0-8.8s-3.2-1.6-5.6,1.6c-4.8,7.2-10.4,19.2-12,24.8s-5.6,4-8-0.8 c-3.2-5.6-2.4-16-1.6-20.8c0.8-4,0.8-5.6-1.6-1.6c-4,11.2-4,22.4,4.8,32C184,201.6,187.2,198.4,189.6,192.8z'
                                />
                                <path
                                  style={{
                                    fill: '#CFE7E8',
                                  }}
                                  d='M212,171.2c0,2.4,0,5.6,1.6,0.8c0.8-4.8,0.8-11.2-0.8-15.2s-2.4-4.8-4-3.2s-1.6,2.4,0,4 C210.4,160,212.8,165.6,212,171.2z'
                                />
                                <path
                                  style={{
                                    fill: '#CFE7E8',
                                  }}
                                  d='M228.8,208.8c0,6.4-1.6,6.4-4,0c-0.8-2.4-1.6-2.4-2.4,0.8c0,5.6-2.4,6.4-4,0.8 c-0.8-2.4-0.8-4.8-1.6-0.8c-0.8,3.2,0,5.6,1.6,8c1.6,1.6,4,1.6,4.8-0.8s1.6-2.4,3.2-0.8c1.6,1.6,8,0,4.8-8.8 C229.6,204,228.8,204.8,228.8,208.8z'
                                />
                                <path
                                  style={{
                                    fill: '#CFE7E8',
                                  }}
                                  d='M293.6,158.4c2.4,1.6,4.8,5.6,4,10.4c-0.8,4,0,6.4,2.4,0.8c2.4-5.6,0.8-12-1.6-16s-3.2-2.4-4.8-0.8 C292,155.2,291.2,157.6,293.6,158.4z'
                                />
                                <path
                                  style={{
                                    fill: '#CFE7E8',
                                  }}
                                  d='M252.8,160.8c0,2.4,0.8,4,4,4.8c6.4,8.8,13.6,18.4,20,27.2c0.8,8,2.4,16,3.2,23.2 c1.6,16,4.8,37.6,2.4,47.2c-1.6,7.2,0,9.6,3.2-0.8s3.2-20.8,0.8-36c-0.8-6.4-0.8-13.6-1.6-21.6c10.4,16.8,20.8,32.8,24.8,44 c2.4,6.4,4.8,7.2,2.4-0.8c-2.4-11.2-12.8-30.4-28.8-54.4c-0.8-6.4-0.8-12.8-0.8-17.6c2.4,2.4,4,0.8,3.2-2.4 c-1.6-6.4-4-11.2-6.4-17.6c-0.8-3.2-4-3.2-5.6,0.8c-1.6,4.8-1.6,5.6,0,8.8c0,4,0.8,9.6,1.6,15.2c-2.4-4-6.4-9.6-9.6-13.6 c4,1.6,7.2,0.8,3.2-4c-4-4-9.6-8.8-12.8-12c-3.2-3.2-4.8-0.8-4.8,1.6C252.8,156.8,253.6,158.4,252.8,160.8z'
                                />
                                <path
                                  style={{
                                    fill: '#CFE7E8',
                                  }}
                                  d='M298.4,183.2c-0.8,4-2.4,2.4-3.2-0.8c-0.8-1.6-1.6-0.8-1.6,2.4c0.8,3.2,1.6,5.6,4,3.2 c1.6-1.6,1.6-1.6,4,0c1.6,1.6,3.2,0,4-0.8c0-0.8,0.8-2.4,0-6.4s-1.6-1.6-2.4,1.6s-2.4,4-3.2,0C300,179.2,298.4,180,298.4,183.2z'
                                />
                                <path
                                  style={{
                                    fill: '#CFE7E8',
                                  }}
                                  d='M316.8,235.2c0.8,14.4,2.4,20.8-6.4,31.2c-9.6,10.4-16,13.6-20,14.4c-5.6,1.6-7.2,4,0.8,3.2 c12-0.8,13.6-0.8,24-12.8c5.6-6.4,8-14.4,8-33.6c-0.8-33.6-4.8-48-4.8-66.4c1.6,1.6,4,1.6,3.2-1.6c-1.6-4-2.4-8.8-3.2-12.8 c-1.6-4-2.4-5.6-4-3.2c-1.6,2.4-3.2,3.2-4,4.8s-1.6,4,0,6.4C315.2,204,316,220.8,316.8,235.2z'
                                />
                                <path
                                  style={{
                                    fill: '#CFE7E8',
                                  }}
                                  d='M337.6,239.2c0.8,8,2.4,13.6,0,23.2c-0.8,2.4,0.8,4,2.4,0c7.2-13.6,2.4-25.6,1.6-33.6 c-0.8-12-5.6-43.2-6.4-56l0.8,0.8c3.2,1.6,7.2,3.2,4.8-1.6c-2.4-4-4.8-11.2-6.4-16c-1.6-4.8-2.4-4.8-4.8-0.8 c-4.8,6.4-1.6,12.8,0,20.8C332.8,203.2,336.8,231.2,337.6,239.2z'
                                />
                                <path
                                  style={{
                                    fill: '#CFE7E8',
                                  }}
                                  d='M354.4,194.4c2.4,2.4,4,7.2,5.6,9.6c1.6,4,3.2,0.8,3.2-1.6c0-2.4-0.8-9.6,0-12c1.6-4,4,1.6,4.8-0.8 c0.8-1.6-0.8-2.4-1.6-4c-0.8-2.4-1.6-1.6-3.2-0.8c-1.6,1.6-2.4,3.2-2.4,4c0,2.4,0,4.8,0,8.8c0,3.2-0.8,3.2-1.6,1.6 c-0.8-2.4-3.2-8-4.8-9.6c-1.6-1.6-4-0.8-4,1.6c0,2.4,0,1.6,0,4C350.4,196.8,353.6,196.8,354.4,194.4z'
                                />
                                <path
                                  style={{
                                    fill: '#CFE7E8',
                                  }}
                                  d='M352.8,225.6c0,2.4,3.2-0.8,5.6-2.4s9.6-6.4,12.8-8c3.2-1.6,2.4-2.4,1.6-5.6c0-3.2-2.4-0.8-4.8,1.6 s-9.6,7.2-12,9.6S352.8,224,352.8,225.6z'
                                />
                                <path
                                  style={{
                                    fill: '#CFE7E8',
                                  }}
                                  d='M336,268.8c-3.2-6.4-3.2-12.8-3.2-18.4c0-4.8-0.8-8.8-2.4-0.8c-4.8,19.2-1.6,23.2,3.2,27.2 c6.4,5.6,8.8,6.4,12,0.8c6.4-9.6,8.8-17.6,12-22.4c3.2-4,3.2-0.8,4.8,0.8c4,4.8,7.2,6.4,12.8,7.2c5.6,0.8,15.2-4,14.4-21.6 c-0.8-11.2-1.6-25.6-2.4-41.6c5.6,7.2,9.6,13.6,13.6,19.2c1.6,10.4,2.4,20,2.4,27.2c-0.8,8.8,1.6,8.8,3.2,0c0.8-3.2,0.8-11.2,0-20 c7.2,9.6,11.2,15.2,13.6,20c3.2,5.6,4.8,9.6,4-0.8c0-4-1.6-7.2-6.4-14.4c-4.8-6.4-8.8-12.8-12.8-19.2c-1.6-15.2-3.2-32-3.2-40.8 c2.4,1.6,4,0,2.4-3.2c-0.8-3.2-3.2-12.8-4.8-16c-1.6-3.2-3.2-3.2-4.8,0.8c-1.6,3.2-3.2,4.8-2.4,7.2c0.8,15.2,2.4,29.6,4.8,42.4 c-4-5.6-8-11.2-11.2-16c0-5.6-0.8-11.2-0.8-16.8c2.4,1.6,3.2,1.6,2.4-2.4c-0.8-3.2-4-11.2-5.6-14.4c-1.6-3.2-2.4-3.2-4-0.8 c-2.4,4-3.2,7.2-0.8,11.2c0,4,0.8,7.2,0.8,11.2c-2.4-3.2-4-6.4-6.4-8.8c2.4,0.8,4-0.8,1.6-3.2s-7.2-6.4-9.6-8.8c-2.4-3.2-4-2.4-4,0 s0,4.8,0,7.2s0,4,2.4,8c5.6,7.2,12,14.4,16.8,21.6c2.4,25.6,3.2,42.4,3.2,52.8c0,6.4-2.4,9.6-5.6,10.4c-3.2,0.8-6.4-0.8-9.6-5.6 c-5.6-8-8-6.4-12,0.8c-4,7.2-7.2,12.8-9.6,17.6C343.2,271.2,339.2,275.2,336,268.8z'
                                />
                                <path
                                  style={{
                                    fill: '#CFE7E8',
                                  }}
                                  d='M412.8,180c0,4.8,1.6,4,2.4,0s0.8-12-1.6-16.8c-2.4-5.6-3.2-3.2-4-1.6c-1.6,2.4-1.6,3.2,0.8,5.6 C411.2,169.6,412.8,175.2,412.8,180z'
                                />
                                <path
                                  style={{
                                    fill: '#CFE7E8',
                                  }}
                                  d='M434.4,229.6c-1.6-33.6-5.6-48-4.8-60.8c3.2,2.4,4,1.6,2.4-2.4s-4-8.8-5.6-13.6 c-1.6-4-2.4-3.2-4.8,0c-2.4,3.2-2.4,5.6-1.6,7.2c4.8,40.8,7.2,62.4,8,75.2c0.8,17.6-3.2,28-20.8,40c-5.6,4-12,8,1.6,4.8 C421.6,276,436,267.2,434.4,229.6z'
                                />
                                <path
                                  style={{
                                    fill: '#CFE7E8',
                                  }}
                                  d='M389.6,264.8c-2.4,3.2,3.2,4.8,4,2.4c1.6,2.4,0,6.4-2.4,8.8c-4,3.2-1.6,4,0.8,1.6 c2.4-1.6,8.8-8.8,4.8-13.6C394.4,262.4,391.2,262.4,389.6,264.8z'
                                />
                              </g>
                              <path
                                style={{
                                  fill: '#FFFFFF',
                                }}
                                d='M372,324c-10.4,0-20,0-30.4,0.8v-3.2c3.2-4,2.4-4,0-8c-0.8-1.6-1.6-3.2-4,0s-2.4,4,0.8,8v3.2 c-79.2,0.8-166.4,0-241.6-0.8c8,13.6,35.2,12.8,60,12.8c22.4,0,89.6,0,180.8-2.4v4c-3.2,4-2.4,4,0,8c2.4,3.2,3.2,1.6,4,0 c0.8-0.8,0.8-1.6,0.8-1.6h12c0,1.6,2.4,2.4,3.2,2.4c0.8,0,3.2-0.8,3.2-2.4h13.6c1.6,2.4,3.2,3.2,5.6,3.2c4.8,0,7.2-5.6,6.4-12.8 C385.6,324.8,381.6,323.2,372,324z M360.8,340c0-1.6-2.4-2.4-3.2-2.4c-0.8,0-3.2,0.8-3.2,2.4h-12c0-0.8-0.8-1.6-2.4-3.2v-4 c10.4,0,21.6-0.8,32.8-0.8c-0.8,2.4-0.8,4.8-0.8,7.2L360.8,340z'
                              />
                              <path
                                style={{
                                  fill: '#CFE7E8',
                                }}
                                d='M372,324c-10.4,0-20,0-30.4,0.8v-3.2c3.2-4,2.4-4,0-8c-0.8-1.6-1.6-3.2-4,0s-2.4,4,0.8,8v3.2 c0,0,0,0-0.8,0l11.2,9.6c8,0,16.8-0.8,24.8-0.8c-0.8,2.4-0.8,4.8-0.8,7.2h-12c0-1.6-2.4-2.4-3.2-2.4c-0.8,0-2.4,0.8-2.4,1.6l5.6,4.8 V344h13.6c1.6,2.4,3.2,3.2,5.6,3.2c4.8,0,7.2-5.6,6.4-12.8C385.6,324.8,381.6,323.2,372,324z'
                              />
                            </g>
                          </svg>
                        ) : (
                          <svg
                            viewBox='0 -4 28 28'
                            fill='none'
                            xmlns='http://www.w3.org/2000/svg'>
                            <g id='SVGRepo_bgCarrier' strokeWidth={0} />
                            <g
                              id='SVGRepo_tracerCarrier'
                              strokeLinecap='round'
                              strokeLinejoin='round'
                            />
                            <g id='SVGRepo_iconCarrier'>
                              <g clipPath='url(#clip0_503_3486)'>
                                <rect
                                  width={28}
                                  height={20}
                                  rx={2}
                                  fill='white'
                                />
                                <mask
                                  id='mask0_503_3486'
                                  style={{
                                    maskType: 'alpha',
                                  }}
                                  maskUnits='userSpaceOnUse'
                                  x={0}
                                  y={0}
                                  width={28}
                                  height={20}>
                                  <rect
                                    width={28}
                                    height={20}
                                    rx={2}
                                    fill='white'
                                  />
                                </mask>
                                <g mask='url(#mask0_503_3486)'>
                                  <path
                                    fillRule='evenodd'
                                    clipRule='evenodd'
                                    d='M28 0H0V1.33333H28V0ZM28 2.66667H0V4H28V2.66667ZM0 5.33333H28V6.66667H0V5.33333ZM28 8H0V9.33333H28V8ZM0 10.6667H28V12H0V10.6667ZM28 13.3333H0V14.6667H28V13.3333ZM0 16H28V17.3333H0V16ZM28 18.6667H0V20H28V18.6667Z'
                                    fill='#D02F44'
                                  />
                                  <rect
                                    width={12}
                                    height={9.33333}
                                    fill='#46467F'
                                  />
                                  <g filter='url(#filter0_d_503_3486)'>
                                    <path
                                      fillRule='evenodd'
                                      clipRule='evenodd'
                                      d='M2.66665 1.99999C2.66665 2.36818 2.36817 2.66666 1.99998 2.66666C1.63179 2.66666 1.33331 2.36818 1.33331 1.99999C1.33331 1.63181 1.63179 1.33333 1.99998 1.33333C2.36817 1.33333 2.66665 1.63181 2.66665 1.99999ZM5.33331 1.99999C5.33331 2.36818 5.03484 2.66666 4.66665 2.66666C4.29846 2.66666 3.99998 2.36818 3.99998 1.99999C3.99998 1.63181 4.29846 1.33333 4.66665 1.33333C5.03484 1.33333 5.33331 1.63181 5.33331 1.99999ZM7.33331 2.66666C7.7015 2.66666 7.99998 2.36818 7.99998 1.99999C7.99998 1.63181 7.7015 1.33333 7.33331 1.33333C6.96512 1.33333 6.66665 1.63181 6.66665 1.99999C6.66665 2.36818 6.96512 2.66666 7.33331 2.66666ZM10.6666 1.99999C10.6666 2.36818 10.3682 2.66666 9.99998 2.66666C9.63179 2.66666 9.33331 2.36818 9.33331 1.99999C9.33331 1.63181 9.63179 1.33333 9.99998 1.33333C10.3682 1.33333 10.6666 1.63181 10.6666 1.99999ZM3.33331 3.99999C3.7015 3.99999 3.99998 3.70152 3.99998 3.33333C3.99998 2.96514 3.7015 2.66666 3.33331 2.66666C2.96512 2.66666 2.66665 2.96514 2.66665 3.33333C2.66665 3.70152 2.96512 3.99999 3.33331 3.99999ZM6.66665 3.33333C6.66665 3.70152 6.36817 3.99999 5.99998 3.99999C5.63179 3.99999 5.33331 3.70152 5.33331 3.33333C5.33331 2.96514 5.63179 2.66666 5.99998 2.66666C6.36817 2.66666 6.66665 2.96514 6.66665 3.33333ZM8.66665 3.99999C9.03484 3.99999 9.33331 3.70152 9.33331 3.33333C9.33331 2.96514 9.03484 2.66666 8.66665 2.66666C8.29846 2.66666 7.99998 2.96514 7.99998 3.33333C7.99998 3.70152 8.29846 3.99999 8.66665 3.99999ZM10.6666 4.66666C10.6666 5.03485 10.3682 5.33333 9.99998 5.33333C9.63179 5.33333 9.33331 5.03485 9.33331 4.66666C9.33331 4.29847 9.63179 3.99999 9.99998 3.99999C10.3682 3.99999 10.6666 4.29847 10.6666 4.66666ZM7.33331 5.33333C7.7015 5.33333 7.99998 5.03485 7.99998 4.66666C7.99998 4.29847 7.7015 3.99999 7.33331 3.99999C6.96512 3.99999 6.66665 4.29847 6.66665 4.66666C6.66665 5.03485 6.96512 5.33333 7.33331 5.33333ZM5.33331 4.66666C5.33331 5.03485 5.03484 5.33333 4.66665 5.33333C4.29846 5.33333 3.99998 5.03485 3.99998 4.66666C3.99998 4.29847 4.29846 3.99999 4.66665 3.99999C5.03484 3.99999 5.33331 4.29847 5.33331 4.66666ZM1.99998 5.33333C2.36817 5.33333 2.66665 5.03485 2.66665 4.66666C2.66665 4.29847 2.36817 3.99999 1.99998 3.99999C1.63179 3.99999 1.33331 4.29847 1.33331 4.66666C1.33331 5.03485 1.63179 5.33333 1.99998 5.33333ZM3.99998 5.99999C3.99998 6.36819 3.7015 6.66666 3.33331 6.66666C2.96512 6.66666 2.66665 6.36819 2.66665 5.99999C2.66665 5.6318 2.96512 5.33333 3.33331 5.33333C3.7015 5.33333 3.99998 5.6318 3.99998 5.99999ZM5.99998 6.66666C6.36817 6.66666 6.66665 6.36819 6.66665 5.99999C6.66665 5.6318 6.36817 5.33333 5.99998 5.33333C5.63179 5.33333 5.33331 5.6318 5.33331 5.99999C5.33331 6.36819 5.63179 6.66666 5.99998 6.66666ZM9.33331 5.99999C9.33331 6.36819 9.03484 6.66666 8.66665 6.66666C8.29846 6.66666 7.99998 6.36819 7.99998 5.99999C7.99998 5.6318 8.29846 5.33333 8.66665 5.33333C9.03484 5.33333 9.33331 5.6318 9.33331 5.99999ZM9.99998 8C10.3682 8 10.6666 7.70152 10.6666 7.33333C10.6666 6.96514 10.3682 6.66666 9.99998 6.66666C9.63179 6.66666 9.33331 6.96514 9.33331 7.33333C9.33331 7.70152 9.63179 8 9.99998 8ZM7.99998 7.33333C7.99998 7.70152 7.7015 8 7.33331 8C6.96512 8 6.66665 7.70152 6.66665 7.33333C6.66665 6.96514 6.96512 6.66666 7.33331 6.66666C7.7015 6.66666 7.99998 6.96514 7.99998 7.33333ZM4.66665 8C5.03484 8 5.33331 7.70152 5.33331 7.33333C5.33331 6.96514 5.03484 6.66666 4.66665 6.66666C4.29846 6.66666 3.99998 6.96514 3.99998 7.33333C3.99998 7.70152 4.29846 8 4.66665 8ZM2.66665 7.33333C2.66665 7.70152 2.36817 8 1.99998 8C1.63179 8 1.33331 7.70152 1.33331 7.33333C1.33331 6.96514 1.63179 6.66666 1.99998 6.66666C2.36817 6.66666 2.66665 6.96514 2.66665 7.33333Z'
                                      fill='url(#paint0_linear_503_3486)'
                                    />
                                  </g>
                                </g>
                              </g>
                              <defs>
                                <filter
                                  id='filter0_d_503_3486'
                                  x={1.33331}
                                  y={1.33333}
                                  width={9.33331}
                                  height={7.66667}
                                  filterUnits='userSpaceOnUse'
                                  colorInterpolationFilters='sRGB'>
                                  <feFlood
                                    floodOpacity={0}
                                    result='BackgroundImageFix'
                                  />
                                  <feColorMatrix
                                    in='SourceAlpha'
                                    type='matrix'
                                    values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
                                    result='hardAlpha'
                                  />
                                  <feOffset dy={1} />
                                  <feColorMatrix
                                    type='matrix'
                                    values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0'
                                  />
                                  <feBlend
                                    mode='normal'
                                    in2='BackgroundImageFix'
                                    result='effect1_dropShadow_503_3486'
                                  />
                                  <feBlend
                                    mode='normal'
                                    in='SourceGraphic'
                                    in2='effect1_dropShadow_503_3486'
                                    result='shape'
                                  />
                                </filter>
                                <linearGradient
                                  id='paint0_linear_503_3486'
                                  x1={1.33331}
                                  y1={1.33333}
                                  x2={1.33331}
                                  y2={7.99999}
                                  gradientUnits='userSpaceOnUse'>
                                  <stop stopColor='white' />
                                  <stop offset={1} stopColor='#F0F0F0' />
                                </linearGradient>
                                <clipPath id='clip0_503_3486'>
                                  <rect
                                    width={28}
                                    height={20}
                                    rx={2}
                                    fill='white'
                                  />
                                </clipPath>
                              </defs>
                            </g>
                          </svg>
                        )}
                      </button>
                      <div
                        className={`dropdown-items ${
                          dropdownState ? 'isVisible' : 'isHidden'
                        }`}>
                        {dropdownValue == 'العربية' ? (
                          <div className='dropdown-item'>
                            <div
                              className='dropdown__link'
                              onClick={() =>
                                handleSetDropdownValue('الإنجليزية')
                              }>
                              <span>الإنجليزية</span>
                            </div>
                          </div>
                        ) : (
                          <div className='dropdown-item'>
                            <div
                              className='dropdown__link'
                              onClick={() => handleSetDropdownValue('العربية')}>
                              <span>العربية</span>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className='header_logo_div'>
                    <a href='/'>
                      <img src='/assets/images/logo.png' alt='logo' />
                    </a>
                  </div>
                </div>
              </div>
            </ContainerPadding>
          </Container>
        </div>
      </div>
    </header>
  );
};

export default Header;
